import { ClassSubjectReqModel, CreateQuestionBankReqModel, LatestQuestionBankViewReq, MigrateReqModal, QuestionBankViewReq } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";

import { TabQuestion } from "../entities/tab-question.entity";

@Injectable()
export class TabQuestionRepo extends Repository<TabQuestion> {
    constructor(private dataSource: DataSource) {
        super(TabQuestion, dataSource.createEntityManager());
    }

    async getAllQuestionBankData(req: LatestQuestionBankViewReq) {
        const classData = this.createQueryBuilder('cq')
        // .orderBy('cq.modified', 'DESC')

        if (req.classId) {
            classData.andWhere(`cq.class = '${req.classId}'`)
        }
        if (req.marks) {
            classData.andWhere(`cq.marks='${req.marks}'`)
        }
        if (req.subject) {
            classData.andWhere(`cq.subject='${req.subject}'`)
        }
        if (req.chapter) {
            classData.andWhere(`cq.chapter='${req.chapter}'`)
        }

        return await classData.getMany();
    }

    async getDistinctSubjects(className?: string) {
        const qb = this.createQueryBuilder('q')
            .select('DISTINCT q.subject', 'subject')
            .where('q.subject IS NOT NULL');

        if (className) {
            qb.andWhere('q.class = :className', { className });
        }

        return (await qb.getRawMany()).map(row => row.subject);
    }

    async getDistinctChapters(className?: string) {
        const qb = this.createQueryBuilder('q')
            .select('DISTINCT q.chapter', 'chapter')
            .where('q.chapter IS NOT NULL');

        if (className) {
            qb.andWhere('q.class = :className', { className });
        }

        return (await qb.getRawMany()).map(row => row.chapter);
    }

    async getDistinctMarks(className?: string) {
        const qb = this.createQueryBuilder('q')
            .select('DISTINCT q.marks', 'marks')
            .where('q.marks IS NOT NULL');

        if (className) {
            qb.andWhere('q.class = :className', { className });
        }

        return (await qb.getRawMany()).map(row => row.marks);
    }

    async getChaptersByClassAndSubject(req: ClassSubjectReqModel): Promise<string[]> {
        const result = await this.createQueryBuilder('q')
            .select('DISTINCT q.chapter', 'chapter')
            .where('q.class = :className', { className: req.className })
            .andWhere('q.subject = :subject', { subject: req.subject })
            .andWhere('q.chapter IS NOT NULL')
            .getRawMany();

        return result.map((item) => item.chapter).filter(Boolean);
    }

    //     async saveOrUpdateQuestion(req: CreateQuestionBankReqModel, encodedQuestion: string): Promise<void> {
    //   const { classId, subject, chapter, topic, qno, difficultyLevel, questionType, marks, userName, language } = req;

    //   let record = await this.findOne({
    //     where: {
    //       q_no: qno,
    //       chapter: String(chapter),
    //       topic: String(topic),
    //     },
    //   });

    //   if (!record) {
    //     record = new TabQuestion();
    //     record.q_no = qno;
    //     record.chapter = String(chapter);
    //     record.topic = String(topic);
    //     record.class = String(classId);
    //     record.subject = String(subject);
    //     record.creation = new Date();
    //     record.owner = userName;
    //     record.status = 'Active';
    //   }

    //   record.marks = String(marks);
    //   record.difficulty = String(difficultyLevel);
    //   record.cognitive = String(questionType);
    //   record.language = 'Multilingual';
    //   record.modified = new Date();
    //   record.modified_by = userName;

    //   if (language === 1) record.question = encodedQuestion;
    //   if (language === 2) record.question_te = encodedQuestion;
    //   if (language === 3) record.question_ur = encodedQuestion;

    //   await this.save(record);
    // }

    async saveOrUpdateQuestion(req: CreateQuestionBankReqModel): Promise<void> {
        const {
            classId, subject, chapter, topic, qno,
            difficultyLevel, questionType, marks,
            userName, questionEn, questionTe, questionUr
        } = req;

        let record = await this.findOne({
            where: {
                q_no: qno,
                chapter: String(chapter),
                topic: String(topic),
            },
        });

        if (!record) {
            record = new TabQuestion();
            record.q_no = qno;
            record.chapter = String(chapter);
            record.topic = String(topic);
            record.class = String(classId);
            record.subject = String(subject);
            record.creation = new Date();
            record.owner = userName;
            record.status = 'Active';
        }

        record.marks = String(marks);
        record.difficulty = String(difficultyLevel);
        record.cognitive = String(questionType);
        //   record.language = 'Multilingual';
        record.modified = new Date();
        record.modified_by = userName;

        if (questionEn?.trim()) record.question = encodeURIComponent(questionEn.trim());
        if (questionTe?.trim()) record.question_te = encodeURIComponent(questionTe.trim());
        if (questionUr?.trim()) record.question_ur = encodeURIComponent(questionUr.trim());

        await this.save(record);
    }


    async getQuestionById(name: number): Promise<TabQuestion> {
        return this.findOne({
            where: { name },
            select: [
                'name', 'class', 'subject', 'chapter', 'topic',
                'q_no', 'cognitive', 'difficulty', 'marks',
                'question', 'question_te', 'question_ur', 'language',
                'owner', 'modified_by', 'creation', 'modified',
                'docstatus', 'status', 'answer_en', 'answer_te', 'answer_ur'
            ]
        });
    }

    async getRequestedMigrationQuestions(req: MigrateReqModal) {
        const classData = this.createQueryBuilder('cq')

        if (req.className) {
            classData.andWhere(`cq.class = '${req.className}'`)
        }
        if (req.subject) {
            classData.andWhere(`cq.subject='${req.subject}'`)
        }
        if (req.chapter) {
            classData.andWhere(`cq.chapter='${req.chapter}'`)
        }
        // classData.limit(5)

        return await classData.getMany();
    }

}